import { IAddress, IOrder } from '../types';

export const formatOrderAddress = (address?: IAddress | null) =>
  Array.from(
    new Set(
      [address?.apartment, address?.name, address?.address, address?.landmark]
        .map((part) => part?.trim())
        .filter(Boolean)
    )
  ).join(', ') || 'Unavailable';

export const getOrderPickupStops = (order: IOrder) => {
  const plan = order.metadata?.routePlan;
  const riders = plan?.riders ?? [];
  const rider = riders.find((item) => item.riderIndex === order.splitPartIndex);

  if (rider) return rider.stops ?? [];
  if (riders.length === 1 && (order.splitPartCount ?? 1) <= 1)
    return riders[0].stops ?? [];
  if ((order.splitPartCount ?? 1) > 1 || riders.length > 1) return [];

  return plan?.orderedStops ?? [];
};
